<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m type2">
					{{ $t('rtr_personal-asset-sale.title1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-asset-sale.text1') }}<br />
					{{ $t('rtr_personal-asset-sale.text2') }}
				</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>
		<div class="bottom_area">
			<div class="catch_box mb_16">
				<p class="title_l fc_white mb_16">
					{{ $t('rtr_personal-asset-sale.title2') }}<br />
					{{ $t('rtr_personal-asset-sale.title3') }}
				</p>
				<p class="fc_white body_m">
					{{ $t('rtr_personal-asset-sale.text3') }}
					{{ $t('rtr_personal-asset-sale.text4') }}<br />
					{{ $t('rtr_personal-asset-sale.text5') }}
				</p>
			</div>

			<div class="bottom_box second">
				<p class="title_l mb_16">
					{{ $t('rtr_personal-asset-sale.title4') }}<br />
					{{ $t('rtr_personal-asset-sale.title5') }}
				</p>
				<p class="body_m">
					{{ $t('rtr_personal-asset-sale.text6') }}<br />
					{{ $t('rtr_personal-asset-sale.text7') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';

export default {
	name: 'sale.m',
	setup() {
		return {};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
